export default __webpack_public_path__ + "static/media/Maroon_5_-_Animals.05928c19.mp3";